/*
  Collection of custom validation rules for trades form
*/
import { required } from '../../helpr/generic-validation-rules';

/*
  Transfer Instruction Initial Field Defaults
*/
export const transferInstructionModalObj = obj => {
  return {
    fields: {
      firstName: {
        value: obj.firstName,
        style: {}
      },
      lastName: {
        value: obj.lastName,
        style: {}
      },
      emailAddress: {
        value: obj.emailAddress,
        style: {}
      },
      securityId: {
        value: obj.securityId,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

/*
  Trade Transfer Form (Transfer Instruction) Initial Fields Configuration
  Validation rules setup for use-validation hook
*/
export const transferInstructionModalValidator = {
  /* Set Default Values plus their respective validation rules*/
  fields: {
    firstName: [required],
    lastName: [required],
    emailAddress: [required],
    securityId: [required]
  },
  dynamicFields: {}
}

